/// <reference types="@angular/localize" />


import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import * as EditorWorker from 'monaco-editor/esm/vs/editor/editor.worker?worker';
import * as JsonWorker from 'monaco-editor/esm/vs/language/json/json.worker?worker';
import * as CssWorker from 'monaco-editor/esm/vs/language/css/css.worker?worker';
import * as HtmlWorker from 'monaco-editor/esm/vs/language/html/html.worker?worker';
import * as TsWorker from 'monaco-editor/esm/vs/language/typescript/ts.worker?worker';


(self as any).MonacoEnvironment = {

   getWorker(_: string, label: string) {
    if (label === 'json') return new JsonWorker.default();
    if (label === 'css' || label === 'scss' || label === 'less') return new CssWorker.default();
    if (label === 'html' || label === 'handlebars' || label === 'razor') return new HtmlWorker.default();
    if (label === 'typescript' || label === 'javascript') return new TsWorker.default();
    return new EditorWorker.default();
  }
};


bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
